import { Injectable } from '@angular/core';
import { ClubConfigResponse, DRRConfig, ServiceConfigurationGroup, ServiceConfigurationSetting, ServicesConfiguration } from '../../modules/servicing-club/servicing-club.types';

@Injectable({
  providedIn: 'root',
})
export class ClubAdapter {

  constructor() {}

  private mapConfigToSettings<T>(
    config: { [key: string]: T } | undefined,
    nameTransform: (key: string, value: T) => string,
    valueTransform: (value: T) => string
  ): ServiceConfigurationSetting[] {
    if (!config) return [];
    return Object.keys(config).map((key) => {
      const value = config[key];
      return {
        name: nameTransform(key, value),
        value: valueTransform(value),
      };
    });
  }

  private toStringValue(value: any): string {
    if (typeof value === 'boolean') return value ? 'Y' : 'N';
    if (typeof value === 'number') return value === 0 ? '' : value.toString();
    return value != null ? value.toString() : '';
  }

  private getDRRConfig(name: string, drrConfig: DRRConfig): any {
    return {
      name,
      value: '',
      enabled: drrConfig?.enabled,
      default: false
    }
  }

  adaptClubConfig = (clubConfigResponse: ClubConfigResponse): ServicesConfiguration => {
    const { clubCode, config } = clubConfigResponse;

    const configurationItems: ServiceConfigurationGroup[] = [
      {
        name: 'DRREnabled',
        value: '',
        enabled: config.drr?.enabled,
        default: false
      },
      this.getDRRConfig('ACCIDENT', config.drr.accident),
      this.getDRRConfig('BATTERY TEST OR REPLACE', config.drr.batteryTestOrReplace),
      this.getDRRConfig('CAR WON\'T START', config.drr.carWontStart),
      this.getDRRConfig('FLAT TIRE', config.drr.flatTire),
      this.getDRRConfig('FUEL/EV CHARGE', config.drr.fuelEVCharge),
      this.getDRRConfig('LOCKED OUT', config.drr.lockedOut),
      this.getDRRConfig('NEED A TOW', config.drr.needATow),
      this.getDRRConfig('STUCK', config.drr.stuck),
    ];

    const towSettings = this.mapConfigToSettings(
      config.tow,
      (key) => 'tow' + key.charAt(0).toUpperCase() + key.slice(1),
      this.toStringValue
    );

    const roadServiceSettings = this.mapConfigToSettings(
      config.roadService,
      (key) => 'roadService' + key.charAt(0).toUpperCase() + key.slice(1),
      this.toStringValue
    );

    const settings: ServiceConfigurationSetting[] = [
      ...towSettings,
      ...roadServiceSettings,
    ];

    return {
      configurationGroup: {
        configurationItem: configurationItems,
        club: clubCode
      },
      settings: {
        setting: settings,
        club: clubCode
      },
      appointmentScheduling: config.appointmentScheduling
    };
  }


}
